import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../Support/with_presenter';
import {CrewShowPresenter} from './CrewShowPresenter';
import {NetworkRequestStatusView} from '../../Components/Utils/NetworkRequestStatusView';
import {FullCrew} from '../../../Models/Crew';
import {Loader} from '../../Components/Utils/Loader';
import {Link} from 'react-router-dom';
import {Sidebar} from './Components/Sidebar';
import {CrewWorkouts} from './Components/LatestCrewWorkouts/CrewWorkouts';
import {MobileNavigation} from './Components/MobileNavigation';
import {ErrorPlaceholder} from '../../Components/Utils/ErrorPlaceholder';

interface OwnProps {
    id: number;
    name: string | null;
}

const CrewsShowComponent: FunctionComponent<OwnProps & PresenterProps<CrewShowPresenter>> = observer(({presenter}) => {
    if (presenter.name === null) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <Loader />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <NetworkRequestStatusView<FullCrew>
            result={presenter.crew}
            loader={() => {
                return (
                    <div className="container">
                        <div className="row">
                            <div className="col-12 d-flex flex-row justify-content-start">
                                <Link to="/crews" className="btn btn-back-arrow">
                                    <i className="bi bi-arrow-left"></i>
                                </Link>
                                <h1>{presenter.name}</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-9">
                                <Loader />
                            </div>
                            <div className="col-12 col-lg-3"></div>
                        </div>
                    </div>
                );
            }}
            error={() => {
                return (
                    <div className="container">
                        <div className="row">
                            <div className="col-12 d-flex flex-row justify-content-start">
                                <Link to="/crews" className="btn btn-back-arrow">
                                    <i className="bi bi-arrow-left"></i>
                                </Link>
                                <h1>{presenter.name}</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-9">
                                <ErrorPlaceholder large />
                            </div>
                            <div className="col-12 col-lg-3"></div>
                        </div>
                    </div>
                );
            }}
            component={(crew: FullCrew) => {
                return (
                    <div className="container">
                        <div className="row">
                            <div className="col-12 d-flex flex-row justify-content-start">
                                <Link to="/crews" className="btn btn-back-arrow">
                                    <i className="bi bi-arrow-left"></i>
                                </Link>
                                <h1>{crew.name}</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <MobileNavigation crew={crew} className="mb-3" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 mb-3 col-lg-9">
                                <CrewWorkouts crew={crew} />
                            </div>
                            <div className="col-12 col-lg-3">
                                <Sidebar fullCrew={crew} />
                            </div>
                        </div>
                    </div>
                );
            }}
        />
    );
});

export const CrewShow = withPresenter<CrewShowPresenter, OwnProps>(
    (props, component) => new CrewShowPresenter(props.id, props.name, component.network.crews),
    CrewsShowComponent,
);
